import type {TrimFeatureAssignmentInput} from '@dms/api/new-vehicle';

import type {AssignmentValues} from './AssignmentDialog';

export const updateTrimAssignmentSet = (
  assignments: TrimFeatureAssignmentInput[],
  featureId: string,
  values: AssignmentValues,
  canViewCost: boolean
): TrimFeatureAssignmentInput[] =>
  assignments.map((assignment) =>
    assignment.featureId === featureId
      ? {
          ...assignment,
          inclusion: values.inclusion,
          priceDeltaNet: values.priceDeltaNet || null,
          costNet: canViewCost ? values.costNet || null : assignment.costNet,
          sortOrder: values.sortOrder,
          appliesIf: {
            ...assignment.appliesIf,
            anyOfVariantIds: values.anyOfVariantIds,
            allOfFeatureIds: values.allOfFeatureIds,
          },
        }
      : assignment
  );
